import React from 'react';
import { ShimmerAvatar, Space, ShimmerTypography, Grid } from '@pitchero/react-ui';

const ProfileLoading = () => (
  <Grid columns="48px 1fr" columnGap="medium" alignItems="center">
    <ShimmerAvatar size={48} />
    <div>
      <Space bottom="xsmall">
        <ShimmerTypography preset="subtitle--small" />
      </Space>
      <ShimmerTypography preset="description" width="50%" />
    </div>
  </Grid>
);

export default ProfileLoading;
